import React from 'react';
import PropTypes from 'prop-types';
import classes from './ProgressBar.module.css';

const ProgressBar = ({ progress }) => {
  return (
    <div className={classes.progressOverlay}>
      <div className={classes.progressBar} style={{ width: `${progress}%` }} />
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
